import axios from "axios";
import { API } from "@/lib/purchases";

export const IMP = `${API}/invoices/import`;
export const STATUS_UI = {
  ready: { label: "✓ Ready", cls: "bg-emerald-500/15 text-emerald-200 border-emerald-500/40" },
  warning: { label: "⚠ Warning", cls: "bg-amber-500/15 text-amber-200 border-amber-500/40" },
  duplicate: { label: "⧉ Duplicate", cls: "bg-sky-500/15 text-sky-200 border-sky-500/40" },
  error: { label: "✕ Error", cls: "bg-rose-500/15 text-rose-200 border-rose-500/40" },
};
export const money = (v) => (v == null ? "—" : `S$${Number(v).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const dmy = (iso) => (iso ? new Date(iso + (iso.length === 10 ? "T00:00:00" : "")).toLocaleDateString("en-SG", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");

export async function downloadBlob(url, filename) {
  const { data } = await axios.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data); a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
}

// what will actually be written, given the user's choices
export function plan(imp, dupAction, decisions, excluded) {
  const rows = imp?.rows || [];
  let importable = 0, skipped = 0, errors = 0, ignored = 0, newC = 0, value = 0;
  const existing = new Set();
  for (const r of rows) {
    if (r.status === "error") { errors++; continue; }
    if (excluded.has(r.row)) { skipped++; continue; }
    if (r.customer_match.type === "possible" && decisions[r.row] === "ignore") { ignored++; continue; }
    if (r.status === "duplicate" && dupAction === "skip") { skipped++; continue; }
    importable++;
    if (r.data.status !== "void") value += r.data.total || 0;
    const m = r.customer_match;
    if (m.type === "existing" || (m.type === "possible" && decisions[r.row] === "existing")) existing.add(m.customer_id); else newC++;
  }
  return { importable, skipped, errors, ignored, newCustomers: newC, existingCustomers: existing.size, value };
}
